<template>
  <div>
    <div v-show="loading">
      <v-skeleton-loader v-for="item in take" :key="item" class="mx-auto" type="list-item" />
    </div>
    <div v-if="!loading && items && items.length">
      <FinishedCoursesList :courses="items" />
      <v-pagination
        v-if="pagesLength > 1"
        :value="page"
        :length="pagesLength"
        :total-visible="7"
        :disabled="loading"
        circle
        @input="pageChanged"
      ></v-pagination>
    </div>
    <v-alert v-else-if="!finishedCourses.loading" type="info" outlined>
      Brak zakończonych szkoleń.
    </v-alert>
  </div>
</template>

<script>
import FinishedCoursesList from '@/components/main/finished-courses/FinishedCoursesList.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('courseExecution');

export default {
  components: {
    FinishedCoursesList
  },
  data: function() {
    return {
      page: 1
    };
  },
  computed: {
    ...mapState(['finishedCourses']),
    items() {
      return this.finishedCourses.items;
    },
    loading() {
      return this.finishedCourses.loading;
    },
    pagesLength() {
      return Math.ceil(this.finishedCourses.count / this.take);
    },
    take() {
      return 10;
    },
    skip() {
      return (this.page - 1) * this.take;
    }
  },
  async mounted() {
    await this.getFinishedCourses({
      search: '',
      skip: this.skip,
      take: this.take
    });
  },
  methods: {
    ...mapActions(['getFinishedCourses']),
    async pageChanged(page) {
      this.page = page;

      await this.getFinishedCourses({
        search: '',
        skip: this.skip,
        take: this.take
      });
    }
  }
};
</script>
